import { atom } from "recoil";
import { CBContactPersonFormFields, CBEditButtonTrigger, CBEditButtonTriggerStatus, CBErrorSectionValidation, CBExtraAddressDeltaFields, CustomerBaseDto, CustomerSearchFilters, ICheckDrivingLicenceRequest, ICreateAttachmentParams, IDocParam, IEditAttachmentParams, IEditCustomerBaseFieldsParams, IGetCargosPlace, IGetProvince, IMapField, IOSapEnum, IUpdateDocumentStatusRequest, MobilePrefix } from "../types";

const defaultList: any[] = [];
export const customerbaseList = atom({
    key: 'customerbaseList',
    default: defaultList
});

export const customerSearchFiltersState = atom<CustomerSearchFilters | null>({
    key: 'CustomerSearchFilters',
    default: null
})

export const customerbaseDetails = atom<CustomerBaseDto | undefined>({
    key: 'customerbaseDetails',
    default: undefined
    
})

export const queryFieldsState = atom<IEditCustomerBaseFieldsParams | undefined>({
    key: 'queryFieldsState',
    default: undefined
})

export const openCustomerBaseModal = atom({
    key: 'openCustomerBaseModal',
    default: false
})

export const sapEnumState = atom({
    key: 'sapEnumState',
    default: {
        languages: [],
        partnerTypes: [],
        customerTypes: [],
        roles: [],
        dealerTypes: [],
        vips: [],
        blacklists: [],
        genders: [],
        divisions: [],
        addressTypes: [],
        termCondTypes: [],
        companyCodes: [],
        communicationChannels: [],
        distributionChannels: [],
        revocationChannels: [],
        revocationReasons: [],
        salesOrganizations: [],
        identifications: [],
        paymentMethods: [],
        paymentTerms: [],
        correspondingVariants: [],
        salesAreas: [],
        classes: [],
        sizingClasses: [],
        //docTypes: [],
        consentTypes: [],
        termTypes: [],
        legalForms: [],
        currencies: [],
        dossierStatus: [],
        digitalIdentityStatus: [],
        buagClass: [],
        extMgmtReason: []
    } as IOSapEnum
})

export const mobilePrefixState = atom<MobilePrefix[] | []> ({
    key: 'mobilePrefixState',
    default: []
})

export const attachmentCreateQueryFieldsState = atom<ICreateAttachmentParams | undefined> ({
    key: 'attachmentCreateQueryFieldsState',
    default: undefined
})

export const attachmentUpdateQueryFieldsState = atom<IEditAttachmentParams | undefined> ({
    key: 'attachmentUpdateQueryFieldsState',
    default: undefined
})

export const countriesState = atom<string[] | []> ({
    key: 'countriesState',
    default: []
})

export const provincesState = atom<IGetProvince[] | []> ({
    key: 'provincesState',
    default: []
})

export const cargosPlacesState = atom<IGetCargosPlace[] | []> ({
    key: 'cargosPlacesState',
    default: []
})

export const checkDrivingLicenceQueryFieldsState = atom<ICheckDrivingLicenceRequest | undefined> ({
   key: 'checkDrivingLicenceQueryFieldsState',
   default: undefined
})

export const updateAttachmentStatusQueryFieldsState = atom<IUpdateDocumentStatusRequest | undefined> ({
    key: 'updateAttachmentStatusQueryFieldsState',
    default: undefined
})

export const updateDossierStatusQueryFieldsState = atom<IUpdateDocumentStatusRequest | undefined> ({
    key: 'updateDossierStatusQueryFieldsState',
    default: undefined
})

export const googleSearchBarClearValueState = atom<boolean> ({
    key: 'googleSearchBarClearValueState',
    default: false
})

/*
export const errorPaymentInfoSectionState = atom<"red"|"black"> ({
    key: 'errorPaymentInfoSectionState',
    default: "black"
})
*/
export const cbEditButtonTriggerState = atom<CBEditButtonTrigger>({
    key: 'cbEditButtonTriggerState',
    default: {
        cbDetails: CBEditButtonTriggerStatus.UNDEFINED,
        cbPersonalInfo: CBEditButtonTriggerStatus.UNDEFINED,
        cbInvoicingAddress: CBEditButtonTriggerStatus.UNDEFINED,
        salesAreas: CBEditButtonTriggerStatus.UNDEFINED,
        cbPaymentInfo: CBEditButtonTriggerStatus.UNDEFINED,
        cbCorporateInfo: CBEditButtonTriggerStatus.UNDEFINED
    }
})
/** Edit a sezioni */
/*export const anotherSectionIsInEditState = atom<boolean> ({
    key: 'anotherSectionIsInEditState',
    default: false
})*/
/** */

export const isGlobalEditModeState = atom<boolean>({
    key: 'CB_isGlobalEditModeState',
    default: false
})

export const isGlobalEditModeFormDirtyState = atom<boolean>({
    key: 'CB_isGlobalEditModeFormDirtyState',
    default: false
})

export const cbErrorSectionValidationState = atom<CBErrorSectionValidation>({
    key: 'cbErrorSectionValidationState',
    default: {
        cbDetails: false,
        cbPersonalOrganizationInfo: false,
        cbInvoicingAddress: false,
        salesAreas: false,
        cbPaymentInfo: false,
        cbCorporateInfo: false,
    }
})

export const cbContactPersonToDeleteArrayState = atom<CBContactPersonFormFields[] | []>({
    key: 'cbContactPersonToDeleteArrayState',
    default: []
})

export const isMobilityVoucherModeState = atom<boolean>({
    key: 'isMobilityVoucherModeState',
    default: false
})

export const defaultSalesAreasState = atom<any[]>({
    key: 'cbDefaultSalesAreasState',
    default: []
})

export const defaultBuagClassesState = atom<any[]>({
    key: 'cbDefaultBuagClassesState',
    default: []
})